import { SITE_METADATA } from '~/data/site-metadata'

export const getImageUrl = (imageId: string, width: number = 1000, quality: number = 80) => {
  const params = new URLSearchParams()
  params.append('width', width.toString())
  params.append('quality', quality.toString())
  const queryString = params.toString()
  const url = `${SITE_METADATA.mediaHostUrl}/assets/${imageId}?${queryString}`
  return url
}
